<template>
    <div class="home">
        <div class="first-wrapper">
            <div class="main flex-bt">
                <div class="left">
                    <div class="title flex-start">
                        <div class="logo-wrapper">
                            <img src="@/assets/images/small-logo.png" alt="">
                        </div>
                        <span>一键开</span>
                        <p class="tag animation-target">LIVE</p>
                    </div>
                    <div class="big-title">即播即赚</div>
                    <div class="tips">直播即时收款，从LOOPSHOP开始</div>
                    <router-link to="/register">
                        <div class="start">免费试用</div>
                    </router-link>
                </div>
                <div class="right">
                    <video ref="video-1" muted preload autoplay loop controls="false" id="myVideo" type="video/mp4"
                        width="100%" webkit-playsinline="true" x-webkit-airplay="allow" playsinline=""
                        x5-video-player-type="h5" x5-video-orientation="portrait" x5-video-player-fullscreen="portraint"
                        :src="HomeList.topvideo">
                        对不起，您的手机不支持本系统
                    </video>
                </div>
            </div>
        </div>

        <div class="video-wrapper">
            <div class="main flex-bt">
                <div class="items">
                    <video ref="video-2" muted preload autoplay loop controls="false" id="myVideo" type="video/mp4"
                        width="100%" webkit-playsinline="true" x-webkit-airplay="allow" playsinline=""
                        x5-video-player-type="h5" x5-video-orientation="portrait" x5-video-player-fullscreen="portraint"
                        :src="HomeList.video1">
                        对不起，您的手机不支持本系统
                    </video>
                </div>
                <div class="items">
                    <video ref="video-3" muted preload autoplay loop controls="false" id="myVideo" type="video/mp4"
                        width="100%" webkit-playsinline="true" x-webkit-airplay="allow" playsinline=""
                        x5-video-player-type="h5" x5-video-orientation="portrait" x5-video-player-fullscreen="portraint"
                        :src="HomeList.video2">
                        对不起，您的手机不支持本系统
                    </video>
                </div>
                <div class="items">
                    <video ref="video-4" muted preload autoplay loop controls="false" id="myVideo" type="video/mp4"
                        width="100%" webkit-playsinline="true" x-webkit-airplay="allow" playsinline=""
                        x5-video-player-type="h5" x5-video-orientation="portrait" x5-video-player-fullscreen="portraint"
                        :src="HomeList.video3">
                        对不起，您的手机不支持本系统
                    </video>
                </div>
                <div class="items">
                    <video ref="video-5" muted preload autoplay loop controls="false" id="myVideo" type="video/mp4"
                        width="100%" webkit-playsinline="true" x-webkit-airplay="allow" playsinline=""
                        x5-video-player-type="h5" x5-video-orientation="portrait" x5-video-player-fullscreen="portraint"
                        :src="HomeList.video4">
                        对不起，您的手机不支持本系统
                    </video>
                </div>
                <div class="items">
                    <video ref="video-6" muted preload autoplay loop controls="false" id="myVideo" type="video/mp4"
                        width="100%" webkit-playsinline="true" x-webkit-airplay="allow" playsinline=""
                        x5-video-player-type="h5" x5-video-orientation="portrait" x5-video-player-fullscreen="portraint"
                        :src="HomeList.video5">
                        对不起，您的手机不支持本系统
                    </video>
                </div>
            </div>
        </div>


        <div class="data-wrapper" ref="numberBox">
            <div class="main">
                <div class="title">{{ HomeList.toptxt1 }}</div>
                <div class="tips">
                    {{ HomeList.toptxt2 }}
                </div>
                <div class="number-box flex-center">
                    <div class="items" v-for="(item, index) in list" :key="index">
                        <h1 class="flex-center">
                            <countTo :ref="'num-' + index" :startVal='item.baseNumber' :endVal='item.num' :duration='2000'>
                            </countTo>

                            <span>{{ item.unit }}</span>
                        </h1>
                        <p>{{ item.tips }}</p>
                    </div>
                </div>
                <router-link to="/register">
                    <a href="#" class="button">免费试用</a>
                </router-link>

            </div>
        </div>

        <div class="advantage-wrapper">
            <div class="main">
                <div v-for="(item, index) in HomeNewsList" :key="index" class="items flex-bt">

                    <div v-if="(index % 2) == 1" class="text">
                        <div class="title">{{ item.title }} </div>
                        <div class="tips">
                            {{ item.detail }}
                        </div>
                        <div class="advantage">
                            <div v-if="item.item1" class="child flex-start">
                                <img src="@/assets/images/advantage.png" alt="">
                                {{ item.item1 }}
                            </div>
                            <div v-if="item.item2" class="child flex-start">
                                <img src="@/assets/images/advantage.png" alt="">
                                {{ item.item2 }}
                            </div>
                            <div v-if="item.item3" class="child flex-start">
                                <img src="@/assets/images/advantage.png" alt="">
                                {{ item.item3 }}
                            </div>
                        </div>
                    </div>
                    <div v-if="index % 2 == 1" class="image">
                        <img :src="item.image" alt="">
                    </div>

                    <div v-if="index % 2 == 0" class="image">
                        <img :src="item.image" alt="">
                    </div>

                    <div v-if="(index % 2) == 0" class="text">
                        <div class="title">{{ item.title }} </div>
                        <div class="tips">
                            {{ item.detail }}
                        </div>
                        <div class="advantage">
                            <div v-if="item.item1" class="child flex-start">
                                <img src="@/assets/images/advantage.png" alt="">
                                {{ item.item1 }}
                            </div>
                            <div v-if="item.item2" class="child flex-start">
                                <img src="@/assets/images/advantage.png" alt="">
                                {{ item.item2 }}
                            </div>
                            <div v-if="item.item3" class="child flex-start">
                                <img src="@/assets/images/advantage.png" alt="">
                                {{ item.item3 }}
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </div>

        <div class="advantage-wrapper advantage-mobile">
            <div class="main">

                <div v-for="(item, index) in HomeNewsList" :key="index" class="items">
                    <div class="image">
                        <img :src="item.image" alt="">
                    </div>

                    <div class="text">

                        <div class="title">{{ item.title }}</div>
                        <div class="tips">
                            {{ item.detail }}
                        </div>
                        <div class="advantage">
                            <div v-if="item.item1" class="child flex-start">
                                <img src="@/assets/images/advantage.png" alt="">
                                {{ item.item1 }}
                            </div>
                            <div v-if="item.item2" class="child flex-start">
                                <img src="@/assets/images/advantage.png" alt="">
                                {{ item.item2 }}
                            </div>
                            <div v-if="item.item3" class="child flex-start">
                                <img src="@/assets/images/advantage.png" alt="">
                                {{ item.item3 }}
                            </div>
                            <div v-if="item.item4" class="child flex-start">
                                <img src="@/assets/images/advantage.png" alt="">
                                {{ item.item4 }}
                            </div>
                            <div v-if="item.item5" class="child flex-start">
                                <img src="@/assets/images/advantage.png" alt="">
                                {{ item.item5 }}
                            </div>
                        </div>
                    </div>



                </div>

            </div>
        </div>

        <div class="compared-wrapper">
            <div class="main">
                <div class="title">电商平台大比拼</div>
                <img class="img" :src="HomeList.bipin1" alt="">
                <img class="mobile-img" :src="HomeList.bipin2" alt="">
                <div class="button-box flex-center">
                    <router-link to="/register">
                        <div class="items">免费试用</div>
                    </router-link>
                    <router-link to="/plan">
                        <div class="items active">方案收费</div>
                    </router-link>
                </div>
            </div>
        </div>
        <SwiperContent></SwiperContent>
        <Brand></Brand>
        <Start></Start>
    </div>
</template>

<script>
import SwiperContent from '@/components/SwiperContent.vue'
import Brand from '@/components/Brand.vue'
import Start from '@/components/Start.vue'
import countTo from 'vue-count-to'
export default {
    name: 'Home',
    components: { SwiperContent, Brand, Start, countTo },
    data() {
        return {
            metaInfo: {
                title: 'My Page Title',
                meta: [
                    {
                        name: 'keywords',
                        content: 'vue, meta, info, example'
                    },
                    {
                        name: 'description',
                        content: 'This is an example of how to use Vue Meta Info plugin.'
                    }
                ]
            },
            HomeNewsList: [],
            HomeList: [],
            videoList: ['video-1', 'video-2', 'video-3', 'video-4', 'video-5', 'video-6'],
            timerFun: null,
            list: [
                {
                    baseNumber: 0,
                    num: 12,
                    unit: '%',
                    tips: '提升互动',
                },
                {
                    baseNumber: 0,
                    num: 2,
                    unit: '%',
                    tips: '提升销售',
                },
                {
                    baseNumber: 0,
                    num: 10,
                    unit: '%',
                    tips: '提升商品点击率',
                }
            ]
        }
    },  
	created(option) {
		
		// this.partner_id = this.$getStorage('partner_id')
		// if(!this.partner_id){
		// 	if (this.$route.query.partner_id) {
		// 	    this.partner_id = this.$route.query.partner_id
		// 		this.$setStorage('partner_id', this.partner_id)
		// 		 this.$router.push({ name: 'register', params: {} })
		// 	}
		// }else{
		// 	console.log('partner_id:',this.partner_id)
		// }
			if (this.$route.query.partner_id) {
			    this.partner_id = this.$route.query.partner_id
				this.$setStorage('partner_id', this.partner_id)
				 this.$router.push({ name: 'register', params: {} })
			}
		
		
    },

    mounted() {
        this.videoList.forEach(i => {
            this.$refs[i].controls = false
        })

        const options = {
            root: null, // 根元素，默认为视窗
            rootMargin: '-50px', // 根元素的边界偏移量
            threshold: 0.5, // 元素可见度的阈值，范围为 0.0 到 1.0
        };
        const observer = new IntersectionObserver(this.handleIntersect, options);
        observer.observe(this.$refs.numberBox);

        this.getHomeList()
        this.getHomeNewsList()
		this.$setStorage('ifshow',false); 
    },

    computed: {
        numberBox() {
            return this.$refs.numberBox
        }
    },

    methods: {
        handleIntersect(entries) {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // 元素进入可视区域时执行的操作
                    this.list.forEach((item, index) => {
                        this.$refs['num-' + index][0].start();
                    })
                    // 执行其他操作...
                } else {
                    // 元素离开可视区域时执行的操作
                    console.log('Element is not visible');
                    // 执行其他操作...
                }
            });
        },

        async getHomeList() {
            let fdata = { do: 'getset', goto: 'homeset' }
            let res = await this.$api.funk(fdata)
            this.HomeList = res
            this.list[0].num = parseInt(res.bei1)
            this.list[1].num = parseInt(res.bei2)
            this.list[2].num = parseInt(res.bei3)
        },

        async getHomeNewsList() {
            let fdata = { do: 'json', sjk: 'homebannerlist', limit: 15 }
            let res = await this.$api.funk(fdata)
            this.HomeNewsList = res
        },

        numberInit() {
            this.timerFun = setInterval(() => {
                this.list.map(item => {
                    if (item.baseNumber < item.num) {
                        item.baseNumber++
                    } else {
                        item.baseNumber = item.num
                    }
                    return item
                })
            }, 100)
        },
    }
}
</script>
<style lang="scss" scoped>
.video-wrapper {
    backdrop-filter: blur(3rem);
    background: url('~@/assets/images/small-bg.png')no-repeat center center /100% 100%;
    height: 7.42rem;
    overflow: hidden;
    padding-top: 0.78rem;

    .main {
        position: relative;
    }

    .items {
        width: 3rem;
        height: 5.34rem;
        border-radius: 0.24rem;
        overflow: hidden;


        &:nth-child(1) {
            position: absolute;
            top: 0.16rem;
            left: 0;
        }

        &:nth-child(2) {
            position: absolute;
            top: 1.94rem;
            left: 2.43rem;
            z-index: 10;
        }

        &:nth-child(3) {
            position: absolute;
            top: 0.58rem;
            left: 5.1rem;
        }

        &:nth-child(4) {
            position: absolute;
            top: 2.83rem;
            right: 2.43rem;
            z-index: 10;
        }

        &:nth-child(5) {
            position: absolute;
            top: 0.16rem;
            right: 0;
        }

        video {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }

        //所有控件
        video::-webkit-media-controls-enclosure {
            display: none;
        }

        video::-webkit-media-controls {
            display: none;
        }

        /* 全屏按钮 */
        video::-webkit-media-controls-fullscreen-button {
            display: none;
        }

        /* 播放按钮 */
        video::-webkit-media-controls-play-button {
            display: none;
        }

        /* 进度条 */
        video::-webkit-media-controls-timeline {
            display: none;
        }

        /* 观看的当前时间 */
        video::-webkit-media-controls-current-time-display {
            display: none;
        }

        /* 剩余时间 */
        video::-webkit-media-controls-time-remaining-display {
            display: none;
        }

        /* 音量按钮 */
        video::-webkit-media-controls-mute-button {
            display: none;
        }

        video::-webkit-media-controls-toggle-closed-captions-button {
            display: none;
        }

        /* 音量的控制条 */
        video::-webkit-media-controls-volume-slider {
            display: none;
        }

        /* 所有控件 */
        video::-webkit-media-controls-enclosure {
            display: none;
        }


    }
}

.first-wrapper {
    .left {
        .tips {
            text-align: left;
            font-family: 'Microsoft YaHei';
            font-style: normal;
            font-weight: 400;
            font-size: 0.24rem;
            line-height: 0.34rem;
            /* identical to box height */
            color: #000000;
        }

        .big-title {
            font-family: 'Microsoft YaHei';
            font-style: normal;
            font-weight: 600;
            font-size: 0.8rem;
            line-height: 1.12rem;
            letter-spacing: 0.02em;
            color: #000000;
        }

        .start {
            width: 2.72rem;
            height: 0.8rem;
            background: #E02E43;
            border-radius: 0.08rem;
            margin-top: 0.8rem;
            cursor: pointer;
            text-align: center;
            font-family: 'Microsoft YaHei';
            font-style: normal;
            font-weight: 600;
            font-size: 0.24rem;
            line-height: 0.8rem;
            color: #FFFFFF;
            letter-spacing: 1px;
        }

        .title {
            position: relative;

            .logo-wrapper {
                position: absolute;
                bottom: 0.4rem;
                left: -0.4rem;
                width: 0.78rem;
                height: 0.49rem;

                img {
                    width: 100%;
                    height: 100%;
                    display: block;
                }
            }

            span {
                font-family: 'Microsoft YaHei';
                font-style: normal;
                font-weight: 600;
                font-size: 0.48rem;
                line-height: 0.48rem;
                color: #000000;
            }

            .tag {
                width: 1.18rem;
                height: 0.54rem;
                background: #E02E43;
                border-radius: 0.04rem;
                text-align: center;
                font-family: 'Microsoft YaHei';
                font-style: normal;
                font-weight: 600;
                font-size: 0.32rem;
                line-height: 0.54rem;
                color: #FFFFFF;
                margin-left: 0.08rem;
            }
        }
    }

    .right {
        width: 8.48rem;
        height: 8.8rem;

        video {
            width: 100%;
            height: 100%;
        }

        //所有控件
        video::-webkit-media-controls-enclosure {
            display: none;
        }
    }
}

.compared-wrapper {
    background: url('~@/assets/images/bgs.png')no-repeat center center /100% 100%;
    padding-top: 0.8rem;
    padding-bottom: 0.88rem;
    margin-top: 1.44rem;

    .title {
        font-family: 'Microsoft YaHei';
        font-style: normal;
        font-weight: 600;
        font-size: 0.48rem;
        color: #000000;
        text-align: center;
    }

    .mobile-img {
        width: 8.64rem;
        display: none;
    }

    .img {
        width: 100%;
        display: block;
        margin-top: 0.26rem;
    }

    .button-box {
        margin-top: 0.8rem;

        .items {
            width: 2.72rem;
            height: 0.8rem;
            background: #E02E43;
            border-radius: 0.08rem;
            font-family: 'Microsoft YaHei';
            font-style: normal;
            font-weight: 600;
            font-size: 0.24rem;
            line-height: 0.8rem;
            color: #FFFFFF;
            text-align: center;
            margin: 0 0.2rem;
            cursor: pointer;

            &.active {
                background: #ffffff;
                color: #E02E43;
                border: 1px solid #E02E43;
            }
        }
    }
}




.data-wrapper {
    width: 100%;
    background: #E02E43;
    padding: 0.56rem 0 0.76rem 0;
    color: #ffffff;

    .title {
        font-family: 'Microsoft YaHei';
        font-style: normal;
        font-weight: 600;
        font-size: 0.48rem;
        line-height: 0.68rem;
        text-align: center;
    }

    .tips {
        width: 14.4rem;
        margin: 0 auto;
        text-align: center;
        font-family: 'Microsoft YaHei';
        font-style: normal;
        font-weight: 400;
        font-size: 0.32rem;
        line-height: 0.45rem;
        margin-top: 0.24rem;
    }

    .number-box {
        margin-top: 0.58rem;

        .items {
            width: 4.34rem;
            text-align: center;
            position: relative;

            &::before {
                content: '';
                width: 1px;
                height: 80%;
                top: 0;
                bottom: 0;
                margin: auto 0;
                right: 0;
                position: absolute;
                background: #ffffff;
            }

            &:last-child {
                &::before {
                    content: '';
                    width: 1px;
                    height: 80%;
                    top: 0;
                    bottom: 0;
                    margin: auto 0;
                    right: 0;
                    position: absolute;
                    opacity: 0;
                }
            }

            h1 {
                font-family: 'Microsoft YaHei';
                font-style: normal;
                font-weight: 600;
                font-size: 1.8rem;
                line-height: 1.8rem;

                span {
                    font-size: 0.8rem;
                    line-height: 0.8rem;
                }
            }

            p {
                font-family: 'Microsoft YaHei';
                font-style: normal;
                font-weight: 400;
                font-size: 0.4rem;
                line-height: 0.56rem;
            }
        }
    }

    .button {
        width: 2.72rem;
        height: 0.8rem;
        margin: 0 auto;
        margin-top: 0.8rem;
        text-align: center;
        font-family: 'Microsoft YaHei';
        font-style: normal;
        font-weight: 600;
        font-size: 0.24rem;
        line-height: 0.8rem;
        background: #ffffff;
        border-radius: 0.08rem;
        display: block;
        color: #000000;
    }
}

.advantage-mobile {
    display: none;
}

.advantage-wrapper {
    margin-top: 0.78rem;

    .items {
        margin-bottom: 0.48rem;

        &:last-child {
            margin-bottom: 0;
        }

        .text {
            width: 6rem;
            height: 4rem;
            padding-top: 0.28rem;

            .title {
                width: 5.23rem;
                font-weight: 400;
                font-size: 0.4rem;
                line-height: 0.56rem;
                color: #000000;
                text-align: left;
            }

            .tips {
                width: 5.23rem;
                margin-top: 0.24rem;
                padding-top: 0.24rem;
                border-top: 1px solid #D9D9D9;
                font-family: 'Microsoft YaHei';
                font-style: normal;
                font-weight: 400;
                font-size: 0.2rem;
                line-height: 0.28rem;
                color: #000000;
                text-align: left;
            }

            .advantage {
                margin-top: 0.24rem;

                .child {
                    margin-bottom: 0.18rem;
                    font-family: 'Microsoft YaHei';
                    font-style: normal;
                    font-weight: 400;
                    font-size: 0.24rem;
                    line-height: 0.24rem;
                    /* identical to box height */


                    color: #000000;

                    img {
                        width: 0.2rem;
                        height: 0.2rem;
                        display: block;
                        margin-right: 0.1rem;
                    }
                }
            }
        }

        .image {
            width: 6rem;
            height: 4rem;
            border-radius: 0.24rem;
            overflow: hidden;

            img {
                width: 100%;
                height: 100%;
                display: block;
                object-fit: cover;
            }
        }
    }
}

@media (min-width: 750px) and (max-width: 1200px) {
    .video-wrapper .main {
        height: 100%;
    }

    .advantage-wrapper .items .text {
        height: auto;
    }

    .advantage-wrapper .items .text .tips {
        font-size: 0.26rem;
        line-height: 0.38rem;
        width: 100%;
        line-height: inherit;
    }
}

@media (max-width: 750px) {
    .first-wrapper .main {
        display: block;
        position: relative;
        height: 16rem;

        .left {
            position: absolute;
            top: 10rem;
            left: 0;
            right: 0;
            margin: 0 auto;
        }

        .right {
            height: 9rem;
        }

    }

    .first-wrapper .left .big-title {
        text-align: center;
    }

    .first-wrapper .left .tips {
        text-align: center;
    }

    .first-wrapper .left .start {
        width: 4.54rem;
        height: 1.6rem;
        margin: 0 auto;
        margin-top: 0.48rem;
        font-size: 0.48rem;
        line-height: 1.6rem;
        border-radius: 0.16rem;
    }


    .first-wrapper .left .title .logo-wrapper {
        left: 2rem;
    }

    .first-wrapper .left .title {
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .first-wrapper .right {
        width: 100%;
        transform: scale(1.4);
    }

    .video-wrapper .items {
        width: 2.68rem;
        height: 4.8rem;
    }

    .video-wrapper .items:nth-child(1) {
        left: -1rem;
    }

    .video-wrapper {
        height: 8.64rem;
    }

    .video-wrapper .items:nth-child(2) {
        position: absolute;
        top: 3.2rem;
        left: 0.8rem;
        z-index: 10;
    }

    .video-wrapper .items:nth-child(3) {
        position: absolute;
        top: 0.8rem;
        left: 2.4rem;
    }

    .video-wrapper .items:nth-child(4) {
        position: absolute;
        top: 3.6rem;
        right: 0.8rem;
        z-index: 10;
    }

    .video-wrapper .items:nth-child(5) {
        right: -1rem;
    }

    .data-wrapper .tips {
        width: 100%;
    }

    .data-wrapper {
        padding-top: 1.6rem;
        padding-bottom: 1.6rem;
    }

    .data-wrapper .title {
        padding: 0 0.5rem;
    }

    .data-wrapper .number-box .items h1 {
        font-size: 0.8rem;
        line-height: 1rem;
    }

    .data-wrapper .number-box .items p {
        font-size: 0.3rem;
    }

    .data-wrapper .button {
        display: none;
    }

    .compared-wrapper {
        background: url('~@/assets/images/mobile-bp-bg.png') no-repeat center center/100% 100%;
        height: auto;
        width: 100%;
    }

    .compared-wrapper .main {
        width: 100%;
        padding: 0;
    }

    .compared-wrapper .img {
        display: none;
    }

    .compared-wrapper .mobile-img {
        display: block;
        margin-top: 0.8rem;
    }

    .compared-wrapper .button-box {
        display: block;
    }

    .compared-wrapper .button-box .items {
        margin: 0.24rem auto;
        width: 5rem;
        height: 1.2rem;
        font-size: 0.4rem;
        line-height: 1.2rem;
    }

    .advantage-wrapper {
        display: none;
    }

    .advantage-mobile {
        display: block;
    }

    .advantage-wrapper .items .text {
        width: 100%;
        height: auto;
        margin-bottom: 0.4rem;
    }

    .advantage-wrapper .items .text .tips {
        width: 100%;
        font-size: 0.26rem;
        line-height: 0.38rem;
    }

    .advantage-wrapper .items .image {
        width: 100%;
        height: auto;
    }

    .advantage-wrapper .items .text .advantage .child {
        font-size: 0.32rem;
    }

    .advantage-wrapper .items .text .advantage .child img {
        width: 0.3rem;
        height: 0.3rem;
    }

    .advantage-wrapper .items .text .advantage {
        margin-top: 0.48rem;
    }


}
</style>